import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './AcceptProposal.scss';

const getUtmParams = () => (
  {
    source: 'hiredfeedback',
    medium: 'inapp',
    campaign: 'hiringmanagerhired',
  }
);

class AcceptProposal extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { formUrl, csrfToken } = this.props;
    const utmParams = getUtmParams();

    const newUrl = `${window.location.pathname}?prompt_nps=true&`
      + `utm_source=${utmParams.source}&`
      + `utm_medium=${utmParams.medium}&`
      + `utm_campaign=${utmParams.campaign}`;

    return putRequest(
      formUrl,
      {},
      csrfToken,
    ).then(() => {
      window.location.href = newUrl;
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  render() {
    const { consultantName, buttonStyles, triggerType } = this.props;
    return (
      <ModalTrigger
        triggerText={`Hire ${consultantName}`}
        buttonStyles={buttonStyles}
        submitButtonText={`Yes, hire ${consultantName}`}
        cancelButtonText="Cancel"
        handleSubmit={this.handleSubmit}
        triggerType={triggerType}
        closeAfterSubmit
        idKey="accept-proposal-modal"
      >
        <div className="accept-modal style-guide">
          <h1 className="mb-12">
            You are about to hire
            {consultantName}
            !
          </h1>
          <div className="body-text-1 mb-8">
            By clicking Hire below, you agree to award this project to
            {' '}
            {consultantName}
            .
          </div>
          <div className="body-text-1 mb-3">
            Your account manager will reach out to you and the consultant
            to facilitate next steps.
          </div>
        </div>
      </ModalTrigger>
    );
  }
}

AcceptProposal.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  buttonStyles: PropTypes.string,
  triggerType: PropTypes.string,
};

AcceptProposal.defaultProps = {
  buttonStyles: 'primary',
  triggerType: 'link',
};

export default AcceptProposal;
